import { type PropsWithChildren, useMemo } from 'react';

import { env } from '@/config/env';
import { authService } from '@/features/auth/services/authServiceFactory';
import { ApiClient } from '@/lib/api';

import { HttpAdminCatalogApi, type AdminCatalogApi } from '../api';
import { MockAdminCatalogApi } from '../api/mockAdminCatalogApi';
import { AdminCatalogContext } from './adminCatalogContext';

export function AdminCatalogProvider({
  children,
  api,
}: PropsWithChildren<{ api?: AdminCatalogApi }>) {
  const value = useMemo(
    () =>
      api ??
      (env.catalogDataSource === 'mock'
        ? new MockAdminCatalogApi()
        : new HttpAdminCatalogApi(new ApiClient(env.apiBaseUrl, authService))),
    [api],
  );
  return <AdminCatalogContext.Provider value={value}>{children}</AdminCatalogContext.Provider>;
}
